import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { InfoContentOption } from '../../../components/Info/InfoButton'
import { ProjectDistributionHeaderSettings } from '../../../components/Header/ProjectDistributionHeaderComponent'
import { ProjectDistributionLeaderSelectSettings } from '../../../components/Header/ProjectDistributionLeaderSelectComponent'

export interface PageHeaderState {
  settingsButton?: boolean
  infoButton?: boolean
  infoPopupContent?: InfoContentOption
  monthPicker?: boolean
  yearPicker?: boolean
  monthRangePicker?: ProjectDistributionHeaderSettings
  leaderPicker?: ProjectDistributionLeaderSelectSettings
}

const initialState: PageHeaderState = {
  settingsButton: false,
  infoButton: false,
  monthPicker: false,
  yearPicker: false,
  monthRangePicker: { shown: false, disablePaginationDefaultForwardMonths: false },
  leaderPicker: { shown: false, onlyProjectLeaders: false },
}

export const pageHeaderSlice = createSlice({
  name: 'pageHeader',
  initialState,
  reducers: {
    setInitialState: () => {
      return initialState
    },
    setButtons: (state, action: PayloadAction<PageHeaderState>) => {
      return {
        settingsButton: action.payload.settingsButton,
        infoButton: action.payload.infoButton,
        monthPicker: action.payload.monthPicker,
        yearPicker: action.payload.yearPicker,
        monthRangePicker: action.payload.monthRangePicker,
        leaderPicker: action.payload.leaderPicker,
      }
    },
    setInfoPopupContent: (state, action: PayloadAction<InfoContentOption>) => {
      state.infoPopupContent = action.payload
    },
  },
})

export const getSettingsButtonState = (state: RootState) => state.pageHeader.settingsButton
export const getInfoButtonState = (state: RootState) => state.pageHeader.infoButton
export const getInfoPopupContent = (state: RootState) => state.pageHeader.infoPopupContent
export const getMonthPickerState = (state: RootState) => state.pageHeader.monthPicker
export const getButtonsSettings = (state: RootState) => state.pageHeader
export const getMonthRangePickerDisableFlag = (state: RootState) =>
  state.pageHeader.monthRangePicker?.disablePaginationDefaultForwardMonths
export const getLeaderPickerState = (state: RootState) => state.pageHeader.leaderPicker

export const pageHeaderActions = pageHeaderSlice.actions
export const pageHeaderReducer = pageHeaderSlice.reducer

export default pageHeaderReducer
